import { render, staticRenderFns } from "./ReviewsCounter.vue?vue&type=template&id=4cac4346&scoped=true&"
import script from "./ReviewsCounter.vue?vue&type=script&lang=js&"
export * from "./ReviewsCounter.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCounter.vue?vue&type=style&index=0&id=4cac4346&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac4346",
  null
  
)

export default component.exports